// extracted by mini-css-extract-plugin
export default {"paragraph-seperator":"paragraph-seperator__VHztN"};